document.addEventListener("DOMContentLoaded", function(event) {
  const sliderElem = document.querySelector('variant-radios .option-color-list');
  if (sliderElem){
      var pro_cat_slider = new Flickity( sliderElem, {
              cellAlign: 'left',              
              wrapAround: false,              
              contain: true,
              pageDots: false,
      });
  }
    
      function destroyFlickity() {
      if (pro_cat_slider) {
        pro_cat_slider.destroy();
        pro_cat_slider = null;
      }
    }

    function initFlickity() {
      pro_cat_slider = new Flickity(sliderElem, {
        cellAlign: 'left',
        contain: true,        
        wrapAround: false,  
        pageDots: false
      });
    }
    const tabs = document.querySelectorAll(".inner_label");
    const items = document.querySelectorAll(".inner_item");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {        
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
        const selectedCategory = this.getAttribute("data-label");        
        items.forEach(function (item) {
          const itemCategory = item.getAttribute("data-category");
          if (selectedCategory === "all") {
            item.style.display = "";
          } else {
            // Show item if its category includes selected tab (e.g., "red" in "red-rooted")
            if (itemCategory && itemCategory.includes(selectedCategory)) {
              item.style.display = "";
            } else {
              item.style.display = "none";
            }
          }
        });      
        let blockCount = 0;
        items.forEach(el => {
        if (getComputedStyle(el).display === 'block') {
        blockCount++;
        }
        });
        
        console.log("Total display:block elements:", blockCount);

        pro_cat_slider.reloadCells();
        pro_cat_slider.select(0);
         // Re-init Flickity
        // destroyFlickity();
        // initFlickity();
      });
    });

// =======================================
  const customSelect = document.querySelector(".custom-select");
                if (customSelect){
                      const selected = customSelect.querySelector(".selected");
                      const options = customSelect.querySelector(".select-options");    
                        selected.addEventListener("click", () => {
                        options.style.display = options.style.display === "block" ? "none" : "block";
                        });      
                        document.addEventListener("click", (e) => {
                        if (!customSelect.contains(e.target)) {
                        options.style.display = "none";
                        }
                        });
                }          

  const setFinanceLinkAttributes = function(selector) {
    document.querySelectorAll(selector).forEach(function(link) {
      link.setAttribute('href', '#');
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.style.pointerEvents = 'auto';
      link.style.position = 'relative';
      link.style.zIndex = '5';
    });
  };

  setFinanceLinkAttributes('#klarna_more');
  setFinanceLinkAttributes('#afterpay_more');

  // Policy-safe copy guard for Klarna labels rendered by custom blocks/widgets.
  document.querySelectorAll('.cstm_block_klarna').forEach(function(block) {
    const html = block.innerHTML;
    block.innerHTML = html
      .replace(/Buy now,\s*Pay Later,\s*No fees\./gi, 'Buy now, pay later. No interest.')
      .replace(/\bNo fees\b/gi, 'No interest');
  });

  const openWidgetPopup = function(provider) {
    if (provider === 'klarna') {
      const popupElement = document.querySelector('klarna-placement');
      if (popupElement && popupElement.shadowRoot) {
        const btn = popupElement.shadowRoot.querySelector('button.link');
        if (btn) {
          btn.click();
          return true;
        }
      }
      return false;
    }

    if (provider === 'clearpay') {
      const popupElement = document.querySelector('square-placement');
      if (popupElement && popupElement.shadowRoot) {
        const btn = popupElement.shadowRoot.querySelector(
          'button.afterpay-logo, button.link, [role="button"], button, a'
        );
        if (btn) {
          btn.click();
          return true;
        }
      }
      return false;
    }

    return false;
  };

  const openThemeFallbackPopup = function(provider) {
    if (provider === 'klarna') {
      const fallback = document.querySelector('.pop-outer2');
      if (fallback) {
        fallback.style.display = 'block';
        document.body.classList.add('pp_popup_open');
        return true;
      }
    }

    if (provider === 'clearpay') {
      const fallback = document.querySelector('.pop-outer3');
      if (fallback) {
        fallback.style.display = 'block';
        document.body.classList.add('pp_popup_open');
        return true;
      }
    }

    return false;
  };

  const ensureFinanceModal = function() {
    let modal = document.getElementById('finance-info-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'finance-info-modal';
    modal.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99999;align-items:center;justify-content:center;padding:20px;';
    modal.innerHTML =
      '<div style="position:relative;max-width:760px;width:100%;max-height:90vh;overflow:auto;background:#fff;border-radius:4px;padding:20px;">' +
      '<button type="button" id="finance-info-close" style="position:absolute;top:10px;right:12px;border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer;">&times;</button>' +
      '<div id="finance-info-content" style="color:#1a1b18;font-size:16px;line-height:1.6;"></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function(e) {
      if (e.target === modal) modal.style.display = 'none';
    });
    modal.querySelector('#finance-info-close').addEventListener('click', function() {
      modal.style.display = 'none';
    });

    return modal;
  };

  const openCustomFinanceModal = function(provider) {
    const modal = ensureFinanceModal();
    const content = modal.querySelector('#finance-info-content');
    if (!content) return false;

    if (provider === 'clearpay') {
      content.innerHTML =
        '<img src="https://cdn.shopify.com/s/files/1/0816/4510/9534/files/pop-up-img.webp?v=1706611088" alt="Clearpay payment information" style="display:block;width:100%;height:auto;">';
    } else if (provider === 'klarna') {
      content.innerHTML =
        '<h2 style="margin:0 0 18px;text-align:center;letter-spacing:1px;text-transform:uppercase;">Klarna - Buy now, pay later</h2>' +
        '<h3 style="margin:0 0 8px;text-transform:uppercase;font-size:22px;">Shop now. Pay later with Klarna.</h3>' +
        '<p style="margin:0 0 18px;">We are excited to announce we have partnered with Klarna to bring you new ways to pay at checkout.</p>' +
        '<h4 style="margin:0 0 8px;text-transform:uppercase;">Part 1: How it works</h4>' +
        '<p style="margin:0 0 6px;"><strong>Step 1:</strong> Add products to your cart and select "Klarna" when you check out.</p>' +
        '<p style="margin:0 0 6px;"><strong>Step 2:</strong> Enter a few personal details and you will know instantly if you are approved.</p>' +
        '<p style="margin:0 0 18px;"><strong>Step 3:</strong> Klarna will send you an email confirmation and reminders when it is time to pay and you can manage your orders and payments in the Klarna app.</p>' +
        '<h4 style="margin:0 0 8px;text-transform:uppercase;">Part 2: Payments information</h4>' +
        '<p style="margin:0 0 8px;"><strong>Pay in 30 days</strong></p>' +
        '<p style="margin:0 0 12px;">Make your purchase today so you can try before you buy. Only pay for what you keep. Pay up to 30 days later. No interest when you pay on time.</p>' +
        '<p style="margin:0 0 8px;"><strong>Pay in 3</strong></p>' +
        '<p style="margin:0 0 12px;">Spread the cost of your purchase into 3 interest-free instalments. The first payment is made at point of purchase, with remaining instalments scheduled automatically every 30 days.</p>' +
        '<p style="margin:0 0 18px;">Klarna is an unregulated credit agreement. 18+, UK residents only. Subject to status. T&Cs and late fees apply.</p>' +
        '<h4 style="margin:0 0 8px;text-transform:uppercase;">Part 3: About Klarna</h4>' +
        '<p style="margin:0;">Pay online or in the app. Download the Klarna app: <a href="https://www.klarna.com/uk/app/" target="_blank" rel="noopener noreferrer">klarna.com/uk/app</a></p>';
    } else {
      return false;
    }

    modal.style.display = 'flex';
    return true;
  };

  // Open embedded Klarna/Clearpay popup across all product template variants.
  document.addEventListener('click', function(event) {
    const klarnaTarget = event.target.closest('#klarna_more, .cstm_block_klarna, .js-klarna-popup, .klarna-single-logo');
    if (klarnaTarget) {
      event.preventDefault();
      event.stopPropagation();
      if (!openWidgetPopup('klarna')) {
        openCustomFinanceModal('klarna');
      }
      return;
    }

    const clearpayTarget = event.target.closest('#afterpay_more, .cstm_block_afterpay, .js-afterpay-popup, .clearpay-single-logo');
    if (clearpayTarget) {
      event.preventDefault();
      event.stopPropagation();
      if (!openWidgetPopup('clearpay')) {
        if (!openThemeFallbackPopup('clearpay')) {
          openCustomFinanceModal('clearpay');
        }
      }
    }
  }, true);



















  // ==================================
  });